import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ClipboardModule } from '@angular/cdk/clipboard';

// *******************************************************
// Environment Components
// *******************************************************
import { environment as env } from '@environments/environment';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';

import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule, Routes } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field'
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio'

import { FlexLayoutModule, BREAKPOINT } from '@angular/flex-layout';

import { AppComponent } from './app.component';
import { LoginComponent } from '@security/login/login.component';
import { AssetListComponent } from 'src/app/organisation-assets/asset-list/asset-list.component';
import { WatchListComponent } from '@components/watch-list/watch-list.component';
import { EventsComponent } from '@components/events/events/events.component';
import { ProfileComponent } from '@admin/users/profile/profile.component';
import { ProfileManageComponent } from '@admin/users/profile-manage/profile-manage.component';
import { ProfileMeComponent } from '@admin/users/profile-me/profile-me.component';

import { SettingsComponent } from '@components/site-settings/settings.component';
import { HelpComponent } from '@components/help/help.component';
import { NotificationsComponent } from '@components/notifications/notifications.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HierarchyLocationComponent } from 'src/app/organisations/hierarchy/hierarchy-location/hierarchy-location.component';
import {
    AccordionModule, ToolbarModule, ContextMenuModule,
    BreadcrumbModule, CarouselModule,
    TabModule, TreeViewModule, SidebarModule, MenuModule, AppBarModule
} from '@syncfusion/ej2-angular-navigations';

import { SplitterModule, DashboardLayoutModule, TimelineModule } from '@syncfusion/ej2-angular-layouts';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import {
    TextBoxModule, NumericTextBoxModule, MaskedTextBoxModule,
    SliderModule, UploaderModule, ColorPickerModule,
    SignatureModule, RatingModule, TextAreaModule
} from '@syncfusion/ej2-angular-inputs';

import { HomeDefaultPageComponent } from '@layout/home-default-page/home-default-page.component';

import {
    // CalendarModule,
    DatePickerModule,
    DateRangePickerModule,
    DateTimePickerModule
} from '@syncfusion/ej2-angular-calendars';

import { RichTextEditorAllModule, RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';

import {
    ReactiveFormsModule,
    FormsModule
} from '@angular/forms';
import {
    DropDownListModule, ComboBoxModule, AutoCompleteModule, MultiSelectModule,
    ListBoxModule, DropDownTreeModule, MentionModule
} from '@syncfusion/ej2-angular-dropdowns';
import { LogoutComponent } from '@security/logout/logout.component';
import { AssetDetailsComponent } from 'src/app/organisation-assets/asset-details/asset-details.component';
import { ApplicationNameComponent } from '@components/application-name/application-name.component';
import { AccountdisabledComponent } from '@admin/users/accountdisabled/accountdisabled.component';
import { ErrorComponent } from './error/error.component';
import { BlankComponent } from '@components/blank/blank.component';
import { HierarchySubLocationComponent } from 'src/app/organisations/hierarchy/hierarchy-sub-location/hierarchy-sub-location.component';
import { HierarchyAssetComponent } from 'src/app/organisations/hierarchy/hierarchy-asset/hierarchy-asset.component';
import { AssetChartsComponent } from 'src/app/organisation-assets/asset-charts/asset-charts.component';

import {
    RangeNavigatorAllModule,
    ChartAllModule,
    SparklineAllModule,
    AccumulationChartModule,
    PieSeriesService,
    AccumulationLegendService,
    AccumulationDataLabelService,
    // ChartModule,
    // AccumulationChartModule
} from '@syncfusion/ej2-angular-charts';

import { InPlaceEditorModule } from '@syncfusion/ej2-angular-inplace-editor';
import { DialogModule } from '@syncfusion/ej2-angular-popups';

import {
    LineSeriesService, CategoryService, SplineSeriesService,
    LegendService, DataLabelService, TooltipService, DateTimeService,
    StripLineService, StackingColumnSeriesService, ScrollBarService,
    ZoomService, ChartAnnotationService, MultiLevelLabelService,
    AreaSeriesService, ExportService, ColumnSeriesService, StackingAreaSeriesService,
    RangeColumnSeriesService, ScatterSeriesService, PolarSeriesService, RadarSeriesService,
    // ILoadedEventArgs, PieSeriesService, AccumulationTooltipService, AccumulationDataLabelService, SelectionService
} from '@syncfusion/ej2-angular-charts';
import { AccountManageComponent } from './admin/accounts/account-manage/account-manage.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';

import { AnnotationsService, CircularGaugeModule } from '@syncfusion/ej2-angular-circulargauge';

import { LinearGaugeModule } from '@syncfusion/ej2-angular-lineargauge';

import {
    ButtonModule,    // Do not Remove !Important for buttons for some reason
    ChipListModule,
    SwitchModule,
    CheckBoxModule,
    
} from '@syncfusion/ej2-angular-buttons';
import { SplitButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AccountsListComponent } from './admin/accounts/accounts-list/accounts-list.component';
import { EditHierarchyAssetComponent } from './dialogs/edit-level-asset/edit-level-asset.component';
import { EditHierarchyLocationComponent } from './dialogs/edit-hierarchy-location/edit-hierarchy-location.component';
import { EditAccountComponent } from './dialogs/edit-account/edit-account.component';

import { GridModule, GridAllModule } from '@syncfusion/ej2-angular-grids';
import { HierarchyDashboardComponent } from './organisations/hierarchy/hierarchy-dashboard/hierarchy-dashboard.component';
import { HomeNavigationComponent } from './layout/home-navigation/home-navigation.component';
import { PrismPDMLogoComponent } from './Components/prism-pdm-logo/prismPDM-logo.component';
import { MaloneGroupLogoComponent } from './Components/malone-group-logo/malone-group-logo.component';
import { ImageFullSizeComponent } from './dialogs/image-full-size/image-full-size.component';
import { EditAssetDatapointsComponent } from './dialogs/edit-asset-datapoints/edit-asset-datapoints.component';
import { EditSensorDatapointComponent } from './dialogs/edit-sensor-datapoint/edit-sensor-datapoint.component';
import { DatapointGraphComponent } from './dialogs/datapoint-graph/datapoint-graph.component';
import { OrganisationDatapointsComponent } from './dialogs/organisation-datapoints/organisation-datapoints.component';
import { AssetTilesGroupComponent } from './organisations/hierarchy/asset-tiles-group/asset-tiles-group.component';
import { HierarchyManagementComponent } from './organisations/hierarchy/management/hierarchy-management/hierarchy-management.component';
import { HierarchyManageAssetComponent } from './organisations/hierarchy/management/hierarchy-manage-asset/hierarchy-manage-asset.component';
import { HierarchyManageLocationComponent } from './organisations/hierarchy/management/hierarchy-manage-location/hierarchy-manage-location.component'
import { UserInvitationComponent } from './dialogs/user-invitation/user-invitation.component';
import { DialogHeaderComponent } from './dialogs/dialog-header/dialog-header.component';
import { EditOrganisationComponent } from './dialogs/edit-organisation/edit-organisation.component';
import { CreateRuleComponent } from './dialogs/create-rule/create-rule.component'
import { AccountManageOrganisationUsersComponent } from './admin/accounts/account-manage-users/account-manage-users.component';
import { AccountManageOrganisationsComponent } from './admin/accounts/account-manage-organisations/account-manage-organisations.component';
import { CommentDialogComponent } from './dialogs/comment-dialog/comment-dialog.component';
import { AccountInviteComponent } from './admin/accounts/account-invite/account-invite.component';
import { AccountManageOrganisationGroupsComponent } from './admin/accounts/account-manage-groups/account-manage-groups.component';
import { DataIntegrationsComponent } from './integrations/data-integrations/data-integrations.component';
import { EditWebhookIntegrationComponent } from './dialogs/edit-webhook-integration/edit-webhook-integration.component';
import { EditWebhookIntegrationNeuronSensorComponent } from './dialogs/edit-webhook-integration-neuronsensor/edit-webhook-integration-neuronsensor.component';
import { DataIntegrationsSensorsComponent } from './integrations/data-integrations-sensors/data-integrations-sensors.component'
import { DashboardRuleEventsComponent } from './organisations/dashboard/dashboard-rule-events/dashboard-rule-events.component';
import { EventDetailsComponent } from './Components/events/event-details/event-details.component';
import { DataIntegrationsDetailComponent } from './integrations/data-integrations-detail/data-integrations-detail.component';
import { DataIntegrationsNeuronsensorsComponent } from './integrations/data-integrations-neuronsensors/data-integrations-neuronsensors.component';
import { EditSensorComponent } from './dialogs/edit-sensor/edit-sensor.component';
import { EditSensorNeuronComponent } from './dialogs/edit-sensor-neuron/edit-sensor-neuron.component';
import { EditLevelPermissionComponent } from './dialogs/edit-level-permission/edit-level-permission.component';
import { RulesComponent } from './Components/rules/rules/rules.component';
import { RuleDetailsComponent } from './Components/rules/rule-details/rule-details.component';
import { AddLevelPermissionComponent } from './dialogs/add-level-permission/add-level-permission.component';
import { DashboardWatchListComponent } from './organisations/dashboard/dashboard/dashboard-watch-list/dashboard-watch-list.component';
import { AddAccountUserComponent } from './dialogs/add-account-user/add-account-user.component';
import { DashboardHealthPanelComponent } from './organisations/dashboard/dashboard/dashboard-health-panel/dashboard-health-panel.component';
import { CameraUploadComponent } from './dialogs/camera-upload/camera-upload.component';
import { RuleListComponent } from './dialogs/rule-list/rule-list.component';
import { ActionListComponent } from './Components/actions/action-list/action-list.component';
import { UserFavouritesComponent } from './Components/user-favourites/user-favourites.component';
import { CreateActionComponent } from './dialogs/create-action/create-action.component';
import { ActionDetailsComponent } from './Components/actions/action-details/action-details.component';
import { CompleteActionComponent } from './dialogs/complete-action/complete-action.component';
import { DashboardActionListComponent } from './organisations/dashboard/dashboard/dashboard-action-list/dashboard-action-list.component';
import { AssetActionsComponent } from './dialogs/asset-actions/asset-actions.component';
import { AssetComparisonComponent } from './organisation-assets/asset-comparison/asset-comparison.component';
import { OrganisationFlaggedAssetsComponent } from './Components/organisation-flagged-assets/organisation-flagged-assets.component';
import { DashboardFlaggedAssetsComponent } from './organisations/dashboard/dashboard/dashboard-flagged-assets/dashboard-flagged-assets.component';
import { AssetSearchDialogComponent } from './dialogs/asset-search-dialog/asset-search-dialog.component';
import { UnverifiedEmailComponent } from './admin/users/unverified-email/unverified-email.component';
import { AssetHistoryComponent } from './dialogs/asset-history/asset-history.component';
import { FilterBoxComponent } from '@components/filter-box/filter-box.component';
import { CreateAssetDistributionComponent } from './dialogs/create-asset-distribution/create-asset-distribution.component';
import { AssetModelsComponent } from './dialogs/asset-models/asset-models.component';
import { TestDistributionComponent } from './dialogs/test-distribution/test-distribution.component';
import { AccountManageFeaturesComponent } from './admin/accounts/account-manage-features/account-manage-features.component';
import { UnauthorisedComponent } from './admin/users/unauthorised/unauthorised.component';
import { ModelsComponent } from './Components/models/models/models.component';
import { RoutingComponent } from './Components/routing/routing.component';
import { RedirectComponent } from './Components/redirect/redirect.component';
import { ModelDetailsComponent } from './Components/models/model-details/model-details.component';
import { AssetTileComponent } from './organisations/hierarchy/asset-tile/asset-tile.component';
import { SparkleLineComponent } from './Components/sparkle-line/sparkle-line.component';
import { DurationSelectorComponent } from './Components/duration-selector/duration-selector.component';
import { ImageContainerComponent } from './Components/image-container/image-container.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { ChatbotComponent } from './Components/chatbot/chatbot.component';
import { EnergyDashboardComponent } from './organisations/energy-dashboard/energy-dashboard.component';
import { EnergyReportingComponent } from './Components/energy-reporting/energy-reporting.component';
import { LinkAssetDatapointsComponent } from './dialogs/link-asset-datapoints/link-asset-datapoints.component';
import { ImageFallbackDirective } from './shared/image-fallback.directive';
import { CommonModule } from '@angular/common';
import { OrganisationDataModelComponent } from './organisations/hierarchy/management/organisation-data-model/organisation-data-model.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AddDataModelNodeComponent } from './dialogs/add-data-model-node/add-data-model-node.component';
import { DashboardCreationComponent } from './organisations/dashboard/dashboard-creation/dashboard-creation.component';
import { DashboardPanelTemplateComponent } from './dialogs/dashboard-panel-template/dashboard-panel-template.component';
import { CustomDashboardComponent } from './organisations/dashboard/custom-dashboard/custom-dashboard.component';
import { DashboardGaugeComponent } from './organisations/dashboard/dashboard-gauge/dashboard-gauge.component';
import { DashboardChartComponent } from './organisations/dashboard/dashboard-chart/dashboard-chart.component';
import { DashboardTextComponent } from './organisations/dashboard/dashboard-text/dashboard-text.component';
import { DashboardListComponent } from './organisations/dashboard/dashboard-list/dashboard-list.component';
import { DashboardShortcutComponent } from './organisations/dashboard/dashboard-shortcut/dashboard-shortcut.component';
import { DashboardRulesComponent } from './organisations/dashboard/dashboard-rules/dashboard-rules.component';
import { DashboardEventsComponent } from './organisations/dashboard/dashboard-events/dashboard-events.component';
import { AssetInformationComponent } from './organisations/hierarchy/asset-information/asset-information.component';
import { DashboardLinearGaugeComponent } from './organisations/dashboard/dashboard-linear-gauge/dashboard-linear-gauge.component';
import { DashboardAnnotatedGaugeComponent } from './organisations/dashboard/dashboard-annotated-gauge/dashboard-annotated-gauge.component';
import { EditDashboardPanelComponent } from './dialogs/edit-dashboard-panel/edit-dashboard-panel.component';
import { DashboardViewerComponent } from './organisations/dashboard/dashboard-viewer/dashboard-viewer.component';
import { VirtualSensorsComponent } from './Components/virtual-sensors/virtual-sensors.component';
import { VirtualSensorDetailsComponent } from './Components/virtual-sensor-details/virtual-sensor-details.component';
import { EditVirtualSensorComponent } from './dialogs/edit-virtual-sensor/edit-virtual-sensor.component';
import { SAPCaseListComponent } from './cmms/sap-case-list/sap-case-list.component';
import { SAPCaseDetailComponent } from './cmms/sap-case-detail/sap-case-detail.component';
import { CreateCmmsCaseComponent } from './dialogs/create-cmms-case/create-cmms-case.component';
import { CreateOrganisationReportComponent } from './dialogs/create-organisation-report/create-organisation-report.component';
import { AddVirtualSensorComponent } from './dialogs/add-virtual-sensor/add-virtual-sensor.component';
import { AccountExpiryComponent } from './Components/account-expiry/account-expiry.component';
import { LoadingTemplateComponent } from './Components/loading-template/loading-template.component';
import { DashboardWebhooksComponent } from './organisations/dashboard/dashboard-webhooks/dashboard-webhooks.component';
import { HistoricalReportsComponent } from './Components/historical-reports/historical-reports.component';
import { DateRangePickerComponent } from './Components/date-range-picker/date-range-picker.component';
import { ActionEditsComponent } from './dialogs/action-edits/action-edits.component';
import { NotificationBannerComponent } from './Components/notification-banner/notification-banner.component';
import { PanelHeaderComponent } from './organisations/dashboard/panel-header/panel-header.component';
import { OverlayContainer, FullscreenOverlayContainer } from '@angular/cdk/overlay';
import { MaintenanceComponent } from './layout/maintenance/maintenance.component';
import { AppConfigComponent } from './admin/app-config/app-config.component';

import { DashboardPieChartComponent } from './organisations/dashboard/dashboard-pie-chart/dashboard-pie-chart.component';
import { TOSComponent } from './security/tos/tos.component';
import { DockContentComponent } from '@layout/dock-content/dock-content.component';
import { DataIntegrationsNeuronsensorsManageComponent } from './integrations/data-integrations-neuronsensors-manage/data-integrations-neuronsensors-manage.component';
import { SwitchAccountsComponent } from './layout/switch-accounts/switch-accounts.component';
import { DataIntegrationsVirtualsensorsManageComponent } from './integrations/data-integrations-virtualsensors-manage/data-integrations-virtualsensors-manage.component';

const CUSTOM_BREAKPOINTS = [
    {
        alias: 'lt-height-sm',
        mediaQuery: 'screen and (max-height: 600px)',
        priority: 1000,
    },
    {
        alias: 'gt-height-md',
        mediaQuery: 'screen and (min-height: 960px)',
        priority: 1001,
    },
];

@NgModule({
    declarations: [
        ImageFallbackDirective,
        AppComponent,
        LoginComponent,
        AssetListComponent,
        WatchListComponent,
        EventsComponent,
        ProfileComponent,
        ProfileManageComponent,
        ProfileMeComponent,
        SettingsComponent,
        HelpComponent,
        NotificationsComponent,
        HierarchyLocationComponent,
        HomeDefaultPageComponent,
        LogoutComponent,
        AssetDetailsComponent,
        ApplicationNameComponent,
        AccountdisabledComponent,
        ErrorComponent,
        BlankComponent,
        HierarchySubLocationComponent,
        HierarchyAssetComponent,
        AssetChartsComponent,
        AccountManageComponent,
        AccountsListComponent,
        EditHierarchyAssetComponent,
        EditHierarchyLocationComponent,
        EditAccountComponent,
        HierarchyDashboardComponent,
        HomeNavigationComponent,
        PrismPDMLogoComponent,
        MaloneGroupLogoComponent,
        ImageFullSizeComponent,
        EditAssetDatapointsComponent,
        EditSensorDatapointComponent,
        DatapointGraphComponent,
        OrganisationDatapointsComponent,
        AssetTilesGroupComponent,
        HierarchyManagementComponent,
        HierarchyManageAssetComponent,
        HierarchyManageLocationComponent,
        UserInvitationComponent,
        DialogHeaderComponent,
        EditOrganisationComponent,
        CreateRuleComponent,
        AccountManageOrganisationUsersComponent,
        AccountManageOrganisationsComponent,
        CommentDialogComponent,
        AccountInviteComponent,
        AccountManageOrganisationGroupsComponent,
        DataIntegrationsComponent,
        EditWebhookIntegrationComponent,
        EditWebhookIntegrationNeuronSensorComponent,
        DashboardRuleEventsComponent,
        DataIntegrationsSensorsComponent,
        EventDetailsComponent,
        DataIntegrationsDetailComponent,
        DataIntegrationsNeuronsensorsComponent,
        EditSensorComponent,
        EditSensorNeuronComponent,
        EditLevelPermissionComponent,
        RulesComponent,
        RuleDetailsComponent,
        AddLevelPermissionComponent,
        DashboardWatchListComponent,
        AddAccountUserComponent,
        DashboardHealthPanelComponent,
        CameraUploadComponent,
        RuleListComponent,
        ActionListComponent,
        UserFavouritesComponent,
        CreateActionComponent,
        ActionDetailsComponent,
        CompleteActionComponent,
        DashboardActionListComponent,
        AssetActionsComponent,
        AssetComparisonComponent,
        OrganisationFlaggedAssetsComponent,
        DashboardFlaggedAssetsComponent,
        AssetSearchDialogComponent,
        UnverifiedEmailComponent,
        AssetHistoryComponent,
        FilterBoxComponent,
        CreateAssetDistributionComponent,
        AssetModelsComponent,
        TestDistributionComponent,
        AccountManageFeaturesComponent,
        UnauthorisedComponent,
        ModelsComponent,
        RoutingComponent,
        RedirectComponent,
        ModelDetailsComponent,
        AssetTileComponent,
        ModelDetailsComponent,
        AssetTileComponent,
        SparkleLineComponent,
        DurationSelectorComponent,
        ImageContainerComponent,
        ConfirmDialogComponent,
        ChatbotComponent,
        EnergyDashboardComponent,
        EnergyReportingComponent,
        LinkAssetDatapointsComponent,
        OrganisationDataModelComponent,
        AddDataModelNodeComponent,
        DashboardCreationComponent,
        DashboardPanelTemplateComponent,
        CustomDashboardComponent,
        DashboardGaugeComponent,
        DashboardChartComponent,
        DashboardTextComponent,
        DashboardListComponent,
        DashboardShortcutComponent,
        DashboardRulesComponent,
        DashboardEventsComponent,
        AssetInformationComponent,
        DashboardLinearGaugeComponent,
        DashboardAnnotatedGaugeComponent,
        EditDashboardPanelComponent,
        DashboardViewerComponent,
        VirtualSensorsComponent,
        VirtualSensorDetailsComponent,
        SAPCaseListComponent,
        SAPCaseDetailComponent,
        EditVirtualSensorComponent,
        CreateCmmsCaseComponent,
        CreateCmmsCaseComponent,
        CreateOrganisationReportComponent,
        AddVirtualSensorComponent,
        AccountExpiryComponent,
        LoadingTemplateComponent,
        DashboardWebhooksComponent,
        HistoricalReportsComponent,
        DateRangePickerComponent,
        ActionEditsComponent,
        NotificationBannerComponent,
        PanelHeaderComponent,
        MaintenanceComponent,
        AppConfigComponent,
        MaintenanceComponent,
        AppConfigComponent,
        PanelHeaderComponent,
        DashboardPieChartComponent,
        TOSComponent,
        DockContentComponent,
        DataIntegrationsNeuronsensorsManageComponent,
        SwitchAccountsComponent,
        DataIntegrationsVirtualsensorsManageComponent,
    ],
    exports: [        
    ],
    bootstrap: [AppComponent], imports: [AuthModule.forRoot({
        ...env.auth,
        httpInterceptor: {
            ...env.httpInterceptor,
        },
    }),
        ClipboardModule,
        // @angular/common/http
        FlexLayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        MatButtonModule,
        MatCardModule,
        MatSidenavModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatListModule,
        RouterModule,
        MatExpansionModule,
        MatTooltipModule,
        MatChipsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatDialogModule,
        MatDatepickerModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        MatRadioModule,
        InPlaceEditorModule,
        DialogModule,
        NgbDropdownModule,
        ButtonModule, // Do not Remove !Important for buttons for some reason
        SplitButtonModule,
        ChipListModule,
        SwitchModule,
        CheckBoxModule,
        ChartAllModule,
        AccumulationChartModule,
        RangeNavigatorAllModule,
        DatePickerModule,
        DateRangePickerModule,
        DateTimePickerModule,
        CdkAccordionModule,
        NgbModule,
        AccordionModule, ToolbarModule, ContextMenuModule, BreadcrumbModule, CarouselModule, TabModule, TreeViewModule, SidebarModule,
        MenuModule, AppBarModule, SplitterModule, DashboardLayoutModule, ListViewModule, TextBoxModule, NumericTextBoxModule,
        MaskedTextBoxModule, SliderModule, UploaderModule, ColorPickerModule, SignatureModule, RatingModule,
        DropDownListModule, ComboBoxModule, AutoCompleteModule, MultiSelectModule, ListBoxModule, DropDownTreeModule, MentionModule,
        GridAllModule,
        GridModule,
        CircularGaugeModule,
        LinearGaugeModule,
        TextAreaModule,
        TimelineModule,
        SparklineAllModule,
        RichTextEditorAllModule,
        CommonModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
        // enabled: !isDevMode(),
        // enabled: env.production || env.devsite,
        enabled: !env.localsite, // Disable service worker for local development to avoid caching issues
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
    })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true, },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
        { provide: OverlayContainer, useClass: FullscreenOverlayContainer }, // matmenu can appear when fullscreen - Git#52
        AnnotationsService, 
        PieSeriesService,
        AccumulationLegendService,
        AccumulationDataLabelService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ]
})
export class AppModule { }